import { render, staticRenderFns } from "./SGUser.vue?vue&type=template&id=61f366fa"
import script from "./SGUser.vue?vue&type=script&lang=js"
export * from "./SGUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports